import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';

const styles = {
    avatar: {
        margin: 10,
    },
    bigAvatar: {
        width: 48,
        height: 48,
    },
};

function SmallAvatar(props) {
    const {classes, ...other} = props;
    return (<Avatar {...other} className={classes.avatar}/>);
}

function BigAvatar(props) {
    const {classes, ...other} = props;
    return (<Avatar {...other} className={classes.bigAvatar}/>);
}


SmallAvatar = withStyles(styles)(SmallAvatar);
BigAvatar = withStyles(styles)(BigAvatar);

export {SmallAvatar, BigAvatar};